import React from 'react'
import Markdown from 'markdown-to-jsx'

import Link from 'components/Link'
import YouTube from 'components/YouTube'
import Footnote from 'components/Footnote'
import Quote from 'components/Quote'
import PostNewsletter from 'components/PostNewsletter'

const Embed = ({ src, ...rest }) =>
   src.startsWith('https://www.youtube.com/') ? (
      <YouTube src={src} {...rest} />
   ) : (
      <div>
         <iframe src={src} {...rest} />
      </div>
   )

const MarkdownComponent = ({ lang, forceWrapper = false, ...rest }) => {
   return (
      <Markdown
         options={{
            forceBlock: true,
            forceWrapper,
            overrides: {
               link: Link,
               footnote: Footnote,
               iframe: Embed,
               quote: Quote,
               newsletter: {
                  component: PostNewsletter,
                  props: {
                     lang,
                  },
               },
               a: ({ href, title, children }) => {
                  const isExternalType = href ? href.indexOf('http') >= 0 || href.indexOf('mailto') >= 0 : false
                  return (
                     <Link type={isExternalType ? 'external' : 'internal'} url={href} linkTitle={title}>
                        {children}
                     </Link>
                  )
               },
            },
         }}
         // className={mode === 'darkMode' ? css(videoStyles) : undefined}
         {...rest}
      />
   )
}
export default MarkdownComponent
